import { OnDestroy, Pipe, PipeTransform, inject } from '@angular/core';
import { ProvidersService } from '@app/services/providers.service';
import { Subscription } from 'rxjs';

@Pipe({
    name: 'providerNameById',
})
export class ProviderNameById implements PipeTransform, OnDestroy {
    private readonly providersService = inject(ProvidersService);

    providersSubscription: Subscription;

    transform(value: string): Promise<string> {
        return new Promise((resolve) => {
            this.providersSubscription = this.providersService.itemsObservable.subscribe((providers) => {
                if (providers?.length) {
                    const provider = this.providersService.getProviderById(value);
                    if (provider?.name) {
                        resolve(provider?.name);
                    } else {
                        resolve('');
                    }
                }
            });
        });
    }

    public ngOnDestroy() {
        this.providersSubscription.unsubscribe();
    }
}
